import GoodSearch from "./goodSearch.jsx";
export default GoodSearch;
